import { cn } from "@/lib/utils"

interface SkeletonGridProps {
  className?: string
  itemCount?: number
}

export function SkeletonGrid({ className, itemCount = 6 }: SkeletonGridProps) {
  return (
    <div className={cn("w-full", className)}>
      <div className="grid grid-cols-2 gap-3">
        {Array.from({ length: itemCount }).map((_, index) => (
          <div 
            key={index} 
            className="flex flex-col gap-2 animate-in fade-in-0 duration-300"
            style={{ 
              animationDelay: `${index * 50}ms`,
              animationFillMode: 'backwards'
            }}
          >
            <div className="w-full aspect-square animate-pulse rounded-[var(--card-radius)] bg-border/70 dark:bg-border/60" />
            <div className="flex justify-center px-2">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 animate-pulse rounded-full bg-border/70 dark:bg-border/60" />
                <div className="w-20 h-4 animate-pulse rounded bg-border/70 dark:bg-border/60" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
} 